/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { addRowBefore as d, addRowAfter as f, addColumnBefore as s, addColumnAfter as C, deleteTable as m, mergeCells as a, splitCell as w, deleteColumn as A, selectionCell as c, deleteRow as p } from "@progress/kendo-editor-common";
import { createProseMirrorTool as r } from "./proseMirrorTool.mjs";
const R = (o, e) => {
  const l = A(o, e);
  if (l && !e) {
    const t = c(o), n = t && t.node(t.depth);
    if (n && n.content.childCount === 1)
      return !1;
  }
  return l;
}, T = (o, e) => {
  const l = p(o, e);
  if (l && !e) {
    const t = c(o), n = t && t.node(t.depth - 1);
    if (n && n.content.childCount === 1)
      return !1;
  }
  return l;
};
var u;
((o) => {
  o.createAddRowBeforeTool = (e) => r(e, d), o.createAddRowAfterTool = (e) => r(e, f), o.createAddColumnBeforeTool = (e) => r(e, s), o.createAddColumnAfterTool = (e) => r(e, C), o.createDeleteRowTool = (e) => r(e, T), o.createDeleteColumnTool = (e) => r(e, R), o.createDeleteTableTool = (e) => r(e, m), o.createMergeCellsTool = (e) => r(e, a), o.createSplitCellTool = (e) => r(e, w);
})(u || (u = {}));
export {
  u as TableEditNS,
  R as deleteColumnCmd,
  T as deleteRowCmd
};
